import { render, staticRenderFns } from "./CadastrarEscalasFuncionario.vue?vue&type=template&id=03475914"
import script from "./CadastrarEscalasFuncionario.vue?vue&type=script&lang=js"
export * from "./CadastrarEscalasFuncionario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports